import React from 'react';
import NavBar from '../../components/NavBar/NavBar';
import HeroSection from '../../components/HeroSection/HeroSection';
import DiscoverSection from '../../components/DiscoverSection/DiscoverSection';
import Footer from '../../components/Footer/Footer';
import { useUI } from '../../contexts/UIContext';
import { useHomeData } from '../../hooks/useHomeData';
import styles from './Home.module.css';

const Home = () => {
    const { size } = useUI();
    const { tickerText, error } = useHomeData();

    // Si hay error en la carga de datos, podemos loggearlo
    // pero continuamos la renderización con valores por defecto
    if (error) {
        console.error('Error loading home data:', error);
    }

    return (
        <div className={styles.homeContainer}>
            <div className={styles.navBarContainer}>
                <NavBar 
                    size={size} 
                    tickerTextId={1}
                    overrideTickerText={tickerText}
                />
            </div>

            <div className={styles.heroSectionContainer}>
                <HeroSection size={size} />
            </div>

            {/* DiscoverSection maneja su propio estado de loading/error */}
            <DiscoverSection componentSize={size} />

            {/* Footer es stateless y solo necesita el año actual */}
            <Footer />
        </div>
    );
};

export default Home;